import { TOptions } from 'i18next';
import { infuse } from '../ioc-config';

// Composable wrapper until we can update to latest vue-i18n with built-in
// composition API support.
// we are using returnEmptyString: false in our i18next config options
// therefore all empty strings will be interpreted as missing key
// and for non PROD environments the key itself will be returned (see parseMissingKeyHandler)
// if we still want to handle empty string as missing translation (not falling back to key)
// we can use the additional `detectEmpty` option flag
export function useI18n() {
  return {
    t: (key, options?: TOptions & { detectEmpty?: boolean }) => {
      const i18next = infuse('i18nService');
      const translation = options ? i18next.t(key, options) : i18next.t(key);

      if (options?.detectEmpty) {
        // check if translation matches key (fallback by parseMissingKeyHandler)
        return translation === key ? '' : translation;
      }

      // just return translation
      return translation;
    },
    exists: (key, options?: TOptions & { detectEmpty?: boolean }) => {
      const i18next = infuse('i18nService');
      const translation = options ? i18next.t(key, options) : i18next.t(key);
      const isEmpty = translation.trim() === '';

      if (translation) {
        if (options?.detectEmpty) {
          // if translation matches key (fallback by parseMissingKeyHandler)
          // we assume the translations does not exist
          return translation !== key;
        }

        // fallback to when translation is space string
        return isEmpty ? !isEmpty : i18next.exists(key, options);
      }
    },
  };
}
